export default "__VITE_ASSET__D$TePtfx__"